import { useQuery } from '@tanstack/react-query'
import type { UseQueryOptions } from '@tanstack/react-query'

interface UseQueryFactoryOptions<TData> {
  queryKey: readonly unknown[]
  queryFn: () => Promise<TData>
  enabled?: boolean
  staleTime?: number
}

export function useQueryFactory<TData = unknown>({
  queryKey,
  queryFn,
  enabled = true,
  staleTime,
}: UseQueryFactoryOptions<TData>) {
  const options: UseQueryOptions<TData> = {
    queryKey,
    queryFn,
    enabled,
    ...(staleTime !== undefined && { staleTime }),
  }

  return useQuery<TData>(options)
}
